<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Creditors</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row dense class="subtitle-2 text--primary">
          <v-col
            cols="12"
            class="mt-1"
            >Total Debt: {{ totalCredit | currency }}</v-col
          >

          <v-col cols="12" sm="12" md="12">
            <v-btn icon>
              <download-excel :data="creditors" :fields="fields" name="creditors">
                <v-icon color="green">mdi-file-excel</v-icon>
              </download-excel>
            </v-btn>
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="creditors"
              :search="search"
              :mobile-breakpoint="zeroValue"
            >
              <template v-slot:item.Balance="{ item }">
                <span style="font-weight: bold">{{
                  item.Balance.toLocaleString()
                }}</span>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="primary" small @click="openDialog(item)">
                  <v-icon left>mdi-plus</v-icon> Make Payment
                </v-btn>
              </template>
              <!-- end -->

              <!-- details template -->
              <template v-slot:item.details="{ item }">
                <v-btn v-if="item.Balance > 0" color="accent" text :to="`/creditors/${item.id}`">
                  Unpaid Invoices <v-icon right>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end of details -->

              <template v-slot:item.statement="{ item }">
                <v-btn
                  color="primary"
                  text
                  :to="`/supplier-statement/${item.id}`"
                >
                 Supplier Statement
                </v-btn>
              </template>

            
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>


      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  components: {
  },
  data: () => ({
    zeroValue: 0,
    totalCredit: 0,
    search: "",
    enableCreate: true,
    searchingProduct: false,
    accountDialog: false,
    accountItem: {},
    pageItems: 100,
    messageDialog: false,
    message: null,
    debtItem: {},
    accountId: null,
    dialog: false,
    customer: {},
    Balance: null,
    amount: null,
    accounts: [],
    loader: false,
    date: new Date().toISOString().substr(0, 10),
    dateReadonly: "",
    todayDate: new Date().toISOString().substr(0, 10),
    headers: [
      { text: "Name", value: "Name" },
      { text: "Current Debt", value: "Balance" },
      { text: "Details", value: "details" },
      { text: "Statement", value: "statement" },
      { text: "Message", value: "message" },
    ],
    fields: {
      Name: "ocrd.Name",
      Balance: "Balance",
    },
    creditors: [],
  }),
  computed: {
    role() {
      return localStorage.getItem("userRole");
    },
    userRole() {
      return localStorage.getItem("userRole");
    }
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    getCreditors() {
      const self = this;
      this.$store
        .dispatch("get", `/creditors`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.creditors = res.ResponseData.creditors;
            self.totalCredit = res.ResponseData.totalCredit;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.getCreditors()]);
  },
};
</script>